import { Button } from '@mui/material';
import { DatePickerInput, Input } from '../../../../components';
import * as Styled from './AnalyticsFilter.styles';
import formOptions from '../../../CreateEventPage/formOptions';
import dayjs from 'dayjs';

type AnalyticsFilterProps = {
  formMethods: any;
  onClearAll: () => void;
  onSearch: () => void;
};

const AnalyticsFilter = ({ formMethods, onClearAll, onSearch }: AnalyticsFilterProps) => {

  return (
    <>
      <Styled.FiltersContainer>
        <div
          style={{
            display: 'flex',
            width: '100%',
            gap: '10px',
          }}
        >
          <DatePickerInput label={'Date'} minDate={null} maxDate={dayjs()} name={'dateStart'} control={formMethods.control} fullWidth />
          <DatePickerInput label={''} minDate={null} maxDate={dayjs()} name={'dateEnd'} control={formMethods.control} fullWidth />
          <Input
            name="eventTags"
            label="Event Tags"
            select
            multiple
            defaultSelectOption="All"
            control={formMethods.control}
            fullWidth
            removeMarginTop
            selectOptions={[{ label: "All", value: "All" }, ...formOptions.eventTags]}
          />
          <Input
            name="eventFormat"
            label="Event Format"
            select
            multiple
            defaultSelectOption="All"
            control={formMethods.control}
            fullWidth
            removeMarginTop
            selectOptions={[{ label: "All", value: "All" }, ...formOptions.eventFormats]}
          />
          <Input
            name="eventType"
            autoComplete="on"
            label="Event Type"
            select
            multiple
            defaultSelectOption="All"
            control={formMethods.control}
            fullWidth
            removeMarginTop
            selectOptions={[{ label: "All", value: "All" }, ...formOptions.eventTypes]}
          />
          <Input
            name="location"
            label="Location"
            select
            defaultSelectOption="All"
            control={formMethods.control}
            fullWidth
            removeMarginTop
            selectOptions={[{ label: "All", value: "All" }, ...formOptions.offices]}
          />
          <div style={{ width: '100%', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Button type="button" variant="contained" color="primary" onClick={onSearch}>Search</Button>
            <Button type="button" onClick={onClearAll}>Clear All</Button>
          </div>
        </div>
      </Styled.FiltersContainer>
    </>
  );
};

export default AnalyticsFilter;
